<template>
  <div>
    <ShowTeams />
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import ShowTeams from "@/views/pages/teams/ShowTeams.vue";

export default {
  name: "Teams",
  components: {
    ShowTeams,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t("TEAMS.TITLE") },
    ]);
  },
};
</script>
